import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import ImageUpload from './components/ImageUpload.vue'
import MaterialPicker from './components/MaterialPicker.vue'
import IconBatchImport from './components/IconBatchImport.vue'

Vue.use(ElementUI)
Vue.component('ImageUpload', ImageUpload)
Vue.component('MaterialPicker', MaterialPicker)
Vue.component('IconBatchImport', IconBatchImport)
Vue.config.productionTip = false

// V97：标签页使用 keep-alive 保留页面状态；再次切回页面时，只刷新服务端列表数据，
// 不销毁组件、不清空表单和分页。路由页若实现 refreshOnActivate() 则优先调用，
// 否则约定调用其 load(currentPage) 方法。
Vue.mixin({
  activated() {
    const matched = this.$route && Array.isArray(this.$route.matched) ? this.$route.matched : []
    const isRouteView = matched.some(record => record.instances && Object.keys(record.instances).some(key => record.instances[key] === this))
    if (!isRouteView) return
    if (!this.__adminRouteActivatedOnce) { this.__adminRouteActivatedOnce = true; return }
    this.$nextTick(() => {
      let result
      try {
        if (typeof this.refreshOnActivate === 'function') result = this.refreshOnActivate()
        else if (typeof this.load === 'function') result = this.load(this.page)
      } catch (error) { result = Promise.reject(error) }
      if (result && typeof result.catch === 'function') result.catch(() => {})
    })
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
